import PropTypes from 'prop-types';
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import SideNav from './SideNav';
import Toc, { TocProvider } from './Toc';

const styles = require('./Main-styles.module.scss');

const propTypes = {
  location: PropTypes.object.isRequired,
};

function Main({ children, ...props }) {
  return (
    <Container fluid>
      <Row className="flex-xl-nowrap">
        <TocProvider>
          <Col as={SideNav} xs={12} md={3} xl={2} location={props.location} />
          <Col as={Toc} className="d-none d-xl-block" xl={2} />
          <Col
            xs={12}
            md={9}
            xl={8}
            as="main"
            id="rb-docs-content"
            className={styles.main}
          >
            {children}
          </Col>
        </TocProvider>
      </Row>
    </Container>
  );
}

Main.propTypes = propTypes;

export default Main;
